import type { Regime } from '../types';
import type { RegimeFilterValue } from '../components/Filters/RegimeFilter';

/**
 * Pure translation between the catalog's `?regime=` URL param, the backend
 * `regimes` query values, and the RegimeFilter's active-pill state.
 *
 * URL form is a CSV of real regime tokens (`FAT`, `FAD`, or `FAT,FAD`) so the
 * address bar stays honest; the `ambos` pill is a UI-only alias for both.
 */

// Canonical regime order — also the de-dupe / normalize order for the URL value.
export const REGIME_TOKENS: Regime[] = ['FAT', 'FAD'];

/** Parse `?regime=FAT,FAD` → ordered, de-duped, valid Regime[]; junk → []. */
export function readRegimes(raw: string | null): Regime[] {
  if (!raw) return [];
  const seen = new Set<string>(raw.split(',').map((t) => t.trim().toUpperCase()));
  return REGIME_TOKENS.filter((r) => seen.has(r));
}

/** Selected regimes → the active filter pill. */
export function regimeValueOf(selected: Regime[]): RegimeFilterValue {
  if (selected.length === 0) return 'todos';
  if (selected.length >= 2) return 'ambos';
  return selected[0]; // 'FAT' | 'FAD'
}

/** Filter pill → URL `regime` param value; `null` means remove the param. */
export function regimeToUrlValue(value: RegimeFilterValue): string | null {
  if (value === 'todos') return null;
  if (value === 'ambos') return 'FAT,FAD';
  return value; // 'FAT' | 'FAD'
}
